import TruncatedTextColumn from './TruncatedTextColumn';

export default TruncatedTextColumn;
